
const FacadeMixin = {

  facade() {
    return this._facade
  }
}

export default FacadeMixin